// src/components/GameSelection/GameSelection.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GameSelection.css';

const GameSelection = () => {
  const navigate = useNavigate();

  const availableGames = [
    {
      id: 'rummy',
      name: 'Rummy',
      description: 'Classic card game with multiple variations',
      image: '🃏',
      players: '2-9 Players',
      status: 'Available',
      minBet: '₹1',
      route: '/multiplayer',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }
  ];

  const handleGameSelect = (game) => {
    console.log(`🎮 Selected game: ${game.name}`);
    navigate(game.route);
  };

  return (
    <div className="game-selection-container">
      {/* Header - Made smaller */}
      <div className="game-selection-header">
        <h1 className="game-selection-title">
          <span className="game-icon">🎮</span>
          Welcome to JV Games
        </h1>
        <p className="game-selection-subtitle">
          Select a game to start playing
        </p>
      </div>

      {/* Games Grid - Adjusted spacing */}
      <div className="games-grid">
        {availableGames.map((game) => (
          <div 
            key={game.id}
            className="game-card"
            onClick={() => handleGameSelect(game)}
            style={{ 
              background: game.color,
              cursor: 'pointer',
              border: 'none'
            }}
          >
            <div className="game-card-content">
              <div className="game-card-header">
                <div className="game-image">{game.image}</div>
                <div className="game-status-badge">
                  {game.status}
                </div>
              </div>
              
              <div className="game-card-body">
                <h3 className="game-name">{game.name}</h3>
                <p className="game-description">{game.description}</p>
                
                <div className="game-details">
                  <div className="game-detail">
                    <span className="detail-icon">👥</span>
                    <span className="detail-text">{game.players}</span>
                  </div>
                  <div className="game-detail">
                    <span className="detail-icon">💰</span>
                    <span className="detail-text">From {game.minBet}</span>
                  </div>
                </div>
              </div>
              
              <div className="game-card-footer">
                <button className="play-button">
                  Play Now <span className="arrow">→</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Info - Made smaller */}
      <div className="quick-info">
        <div className="info-card">
          <div className="info-icon">⚡</div>
          <div className="info-content">
            <h3>Quick Play</h3>
            <p>Join games instantly or create your own</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameSelection;